module.exports = __webpack_public_path__ + "static/media/venturecity-logo.86cf5856.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/venturecity-logo.png
// module id = 1177
// module chunks = 0